var render = function render(){var _vm=this,_c=_vm._self._c;return _c('survey-send-invitations',{attrs:{"template-id":"OpinionSurvey","management-route":"opinion-survey"}})
}
var staticRenderFns = []

export { render, staticRenderFns }